// Node Modules
import { connect } from 'react-redux';

// Actions
import {
  setDesktop,
  setMobile,
  setTablet,
} from '@/store/actions/viewPortActions';

// Components
import App from '../../src/App';
import LocationBody from '@/components/location/LocationBody';

// Queries
import { fetchLocationContent } from '@/graphql/location';

const Location = ({
  viewPorts,
  setDesktop,
  setMobile,
  setTablet,
  content,
  sharedContent,
}) => {
  const metaData = {
    canonicalUrl: process.env.CPI_URL_HOSTNAME,
    headTitle: content.metaTitle || `CPI ${content.city}`,
    metaDescription: content.metaDescription || '',
    noIndex: false,
  };

  const buttonTexts = {
    shareText: content.shareText,
    photosText: content.photosText,
  };

  return (
    <App
      viewPorts={viewPorts}
      setDesktop={setDesktop}
      setMobile={setMobile}
      setTablet={setTablet}
      isMobile={viewPorts.isMobile}
      isDesktop={viewPorts.isDesktop}
      meta={metaData}
      content={sharedContent}
    >
      <LocationBody
        content={content}
        isDesktop={viewPorts.isDesktop}
        isMobile={viewPorts.isMobile}
        buttonTexts={buttonTexts}
        topProgramsTitle={content.topPrograms}
      />
    </App>
  );
};

export const getStaticPaths = async () => {
  return {
    fallback: false,
    paths: [
      {
        params: {
          location: 'monteverde', 
        },
      },
      {
        params: {
          location: 'flamingo', 
        }, 
      },
      {
        params: {
          location: 'heredia', 
        }, 
      },
    ],
  };
};

export const getStaticProps = async ({
  previewData,
  params,
}) => {
  const location = params.location;
  const content = await fetchLocationContent(location, previewData);

  return {
    props: {
      content,
    },
    revalidate: parseInt(
      process.env.CPI_REVALIDATE_STATIC_REGEN_TIME || '7200',
      10
    ),
  };
};

const mapStateToProps = ({
  viewPorts, 
}) => ({
  viewPorts,
});
const mapDispatchToProps = dispatch => ({
  setDesktop: () => dispatch(setDesktop()),
  setMobile: () => dispatch(setMobile()),
  setTablet: () => dispatch(setTablet()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Location);
